import { render, staticRenderFns } from "./SectionH2.vue?vue&type=template&id=11584f3a&scoped=true"
import script from "./SectionH2.vue?vue&type=script&lang=ts"
export * from "./SectionH2.vue?vue&type=script&lang=ts"
import style0 from "./SectionH2.vue?vue&type=style&index=0&id=11584f3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11584f3a",
  null
  
)

export default component.exports